export class Coupon {
  constructor (props) {
    this.id = props.id
    this.type = props.percent_off ? 'percentage' : 'value'
    this.value = (this.type === 'percentage') ? props.percent_off / 100 : props.amount_off
    this.currency = (props.currency || '').toUpperCase()
    this.created_at = props.created_at
  }
}
